export default __webpack_public_path__ + "static/Orlando-Magic-595dcb6fc561a2215c798b88f335f85e.png";